import DownloadMobileModal from './DownloadMobileModal';

export default DownloadMobileModal;
